import FilterContainer from 'components/filters/FilterContainer';
import styled from 'styled-components';

export const Container = styled(FilterContainer).attrs({
  className: 'container',
  'data-testid': 'stacked-calendar-filters',
})`
  padding: 20px 0;
`;
